export default "__VITE_ASSET__Ke2QVSyL__"